import Vue from 'vue';

import AdminBannerLayout from '~/layouts/original/AdminBannerLayout.vue';
import AdminTabLayout from '~/layouts/original/AdminTabLayout.vue';
import AlertLayout from '~/layouts/original/AlertLayout.vue';
import BannerLayout from '~/layouts/original/BannerLayout.vue';
import CalendarLayout from '~/layouts/original/CalendarLayout.vue';
import CardLayout from '~/layouts/original/CardLayout.vue';
import CarouselLayout from '~/layouts/original/CarouselLayout.vue';
import CsvStepperLayout from '~/layouts/original/CsvStepperLayout.vue';
import DataTableLayout from '~/layouts/original/DataTableLayout.vue';
import ExpansionPanelLayout from '~/layouts/original/ExpansionPanelLayout.vue';
import IframeLayout from '~/layouts/original/IframeLayout.vue';
import InputLayout from '~/layouts/original/InputLayout.vue';
import InputWithStepperLayout from '~/layouts/original/InputWithStepperLayout.vue';
import PageTitleLayout from '~/layouts/original/PageTitleLayout.vue';
import RecruitInputLayout from '~/layouts/original/RecruitInputLayout.vue';
import RecruitScheduleSheetLayout from '~/layouts/original/RecruitScheduleSheetLayout.vue';
import RecruitStepTabLayout from '~/layouts/original/RecruitStepTabLayout.vue';
import SalesInputLayout from '~/layouts/original/SalesInputLayout.vue';
import SalesProductCardLayout from '~/layouts/original/SalesProductCardLayout.vue';
import SheetInputDataLayout from '~/layouts/original/SheetInputDataLayout.vue';
import SheetLayout from '~/layouts/original/SheetLayout.vue';
import SlideGroupLayout from '~/layouts/original/SlideGroupLayout.vue';
import StepperLayout from '~/layouts/original/StepperLayout.vue';
import TabLayout from '~/layouts/original/TabLayout.vue';
import TrainingCourseSheetLayout from '~/layouts/original/TrainingCourseSheetLayout.vue';
import TrainingModuleSheetLayout from '~/layouts/original/TrainingModuleSheetLayout.vue';
import TrainingSectionTabLayout from '~/layouts/original/TrainingSectionTabLayout.vue';
import TrainingTestInputLayout from '~/layouts/original/TrainingTestInputLayout.vue';
import TreeviewLayout from '~/layouts/original/TreeviewLayout.vue';
import WindowLayout from '~/layouts/original/WindowLayout.vue';

Vue.component(AdminBannerLayout.name, AdminBannerLayout)
Vue.component(AdminTabLayout.name, AdminTabLayout)
Vue.component(AlertLayout.name, AlertLayout)
Vue.component(BannerLayout.name, BannerLayout)
Vue.component(CalendarLayout.name, CalendarLayout)
Vue.component(CardLayout.name, CardLayout)
Vue.component(CarouselLayout.name, CarouselLayout)
Vue.component(CsvStepperLayout.name, CsvStepperLayout)
Vue.component(DataTableLayout.name, DataTableLayout)
Vue.component(ExpansionPanelLayout.name, ExpansionPanelLayout)
Vue.component(IframeLayout.name, IframeLayout)
Vue.component(InputLayout.name, InputLayout)
Vue.component(InputWithStepperLayout.name, InputWithStepperLayout)
Vue.component(PageTitleLayout.name, PageTitleLayout)
Vue.component(RecruitInputLayout.name, RecruitInputLayout)
Vue.component(RecruitScheduleSheetLayout.name, RecruitScheduleSheetLayout)
Vue.component(RecruitStepTabLayout.name, RecruitStepTabLayout)
Vue.component(SalesInputLayout.name, SalesInputLayout)
Vue.component(SalesProductCardLayout.name, SalesProductCardLayout)
Vue.component(SheetInputDataLayout.name, SheetInputDataLayout)
Vue.component(SheetLayout.name, SheetLayout)
Vue.component(SlideGroupLayout.name, SlideGroupLayout)
Vue.component(StepperLayout.name, StepperLayout)
Vue.component(TabLayout.name, TabLayout)
Vue.component(TrainingCourseSheetLayout.name, TrainingCourseSheetLayout)
Vue.component(TrainingModuleSheetLayout.name, TrainingModuleSheetLayout)
Vue.component(TrainingSectionTabLayout.name, TrainingSectionTabLayout)
Vue.component(TrainingTestInputLayout.name, TrainingTestInputLayout)
Vue.component(TreeviewLayout.name, TreeviewLayout)
Vue.component(WindowLayout.name, WindowLayout)
